// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Drawer_loadingOverlay__HbKHq"};